import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export const getErrorMessage = (error, defaultMessage = "An unexpected error occurred") => {
  if (!error.response) return error.message || defaultMessage;
  const detail = error.response.data?.detail;

  // Handle structured operational errors (new format)
  if (typeof detail === 'object' && detail !== null) {
    // Prioritize user-facing message, then legacy message
    return detail.user_message || detail.message || JSON.stringify(detail);
  }

  // Handle simple string errors (legacy)
  return detail || defaultMessage;
};
